module.exports = __webpack_public_path__ + "img/sqb.7c463a66.png";